import {Injectable} from '@angular/core';
import {StorageHelperService as Base} from "@shared/services/storage-helper.service";

@Injectable({
  providedIn: 'root',
})
export class StorageHelperService extends Base{

}
